import {
    ANODE_LIST_GET,
    ANODE_LIST_GET_F,
    ANODE_LIST_GET_R,
    ANODE_SELECTED_SET
} from '../actionType'

const initialState = {
    anode: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedAnode: null,
}

export default function AnodeReducer (state = initialState, action : any)  {
    switch (action.type) {
        case ANODE_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case ANODE_LIST_GET_F:
            console.log('action called')
            console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                anode: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case ANODE_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case ANODE_SELECTED_SET:
            return {
                ...state,
                selectedAnode: action.payload
            }
        default:
            return state
    }
}